import { DataCache, QueryResultsRelationship } from 'lib/DataCache';
import { PCCache, PCCollection } from 'data/PCCache';
import { VesselServiceListing } from 'data/models/VesselServiceListing';

export class VesselServiceListingCache extends DataCache {
    VesselServiceListings = PCCollection(VesselServiceListing);

    constructor(data : PCCache) {
        super();

        new QueryResultsRelationship(this.VesselServiceListings, data.Vessels, r => r.Vessels);
    }
}


// WEBPACK FOOTER //
// ./apps/portcall/vesselservicelisting/cache.ts